import { Typography } from '../../../../../design-system/components/typography/Typography';
import { TitlePostBlockSliceType } from '../../../../../domains/Prismic/BrandPages/BrandPagesDocument';

import style from './TitlePostBlockSlice.module.css';

export type TitlePostBlockSliceProps = TitlePostBlockSliceType;

export function TitlePostBlockSlice({ title }: TitlePostBlockSliceProps) {
    return (
        <Typography as="h1" scale="secondary-xl-bold" className={style.wrapper}>
            {title}
        </Typography>
    );
}
